// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__-XKOo","author":"Table_author__1ozq8","authorImage":"Table_authorImage__BpNLP","unreadRow":"Table_unreadRow__2KaXk"};